import sprite from "./sprite.svg";

type Image = {
    [key: string]: string;
};

const IMAGES: Image = {
    "license-keys": `${sprite}#licenseKeys`,
    "key-generator": `${sprite}#keyGenerator`,
    projects: `${sprite}#projects`,
    products: `${sprite}#products`,
    users: `${sprite}#users`,
    history: `${sprite}#history`,
    transactions: `${sprite}#transactions`,
};

export default IMAGES;
